import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'

export default class extends Controller {
  initialize () {
    this.scroll = new SmoothScroll(null, {
      offset: 10,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  scrollTo (event) {
    const regionId = event.currentTarget.dataset.regionId
    const anchor = document.querySelector(`#region_${regionId}`)
    this.scroll.animateScroll(anchor)
  }
}
